module.exports = __webpack_public_path__ + "img/introductionBgImg2.a8834e13.png";